






















































# import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import FileList from '@/components/file_list'


export default {
    name: 'absences_table'
    components: {FileList}
    props:
        component:
            type: String
            required: true
        reload:
            type: Boolean
            required: false

    watch:
        reload: (new_reload, old_reload)->
            if new_reload != old_reload
                @get_absences()

    data: ()->
        alert: false
        loading: true
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        absences: []
        state_classes: @$store.state.state_classes
        day_part_options: @$store.state.day_part_options

    computed:
        data_filtered: ()->
            self = @
            data = @absences.filter (x) ->
                start_date = self.date_formatter(x.start)
                end_date = self.date_formatter(x.end)
                user_str = ''
                if self.component == 'company'
                    user_str = x.user_str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase())

                !self.search || user_str \
                || x.user_in_charge_str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.user_in_charge_str.toLowerCase().includes(self.search.toLowerCase())\
                || x.absence_type.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.absence_type.label.toLowerCase().includes(self.search.toLowerCase())\
                || start_date.includes(self.search.toLowerCase()) || start_date.toLowerCase().includes(self.search.toLowerCase())\
                || end_date.includes(self.search.toLowerCase())\
                || x.nb_days.toString().includes(self.search.toLowerCase()) \
                || x.reason.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.reason.toLowerCase().includes(self.search.toLowerCase())\
                || x.state.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.state.label.toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

        has_mutation_right: ()->
            return @has_access_right('absences_self_edit')

        has_deletion_right: ()->
            return @has_access_right('absences_self_delete')

        has_validation_right: ()->
            return @has_access_right('absences_validate')

    methods:
        date_formatter: t.date_formatter
        has_access_right: t.has_access_right

        cancellation: (absence)->
            # console.log 'CANCELLATION A ', absence
            new_state = 'annulation_demandee'
            text = "demander l'annulation de cette absence"
            if absence.state.slug == 'annulation_demandee'
                new_state = 'accepte'
                text = "retirer la demande d'annulation"
            for state in @$store.state.state_choice_set
                if state.slug == new_state
                    absence.state = t.deep_copy(state)
                    @$emit('cancellation', absence, text)
                    return

        cancel_action_text: (state)->
            ret = "Demander l'annulation"
            if state == "annulation_demandee"
                ret = "Retirer la demande d'annulation"
            return ret

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @absences.sort (a,b)->
                modifier = 1
                field_a = a[prop]
                field_b = b[prop]
                if prop == 'absence_type.label'
                    props = prop.split('.')
                    field_a = a[props[0]][props[1]]
                    field_b = b[props[0]][props[1]]
                else if prop == 'state'
                    field_a = a[prop]['slug']
                    field_b = b[prop]['slug']
                if order == 'descending'
                    modifier = -1
                if prop == 'nb_days'
                    if a[prop] < b[prop]
                        return -1 * modifier
                    if a[prop] > b[prop]
                        return 1 * modifier
                    return 0
                else
                    return field_a.toLowerCase().localeCompare(field_b.toLowerCase())*modifier

        handle_size_change: (val)->
            @page_size = val
            return

        handle_current_change: (val)->
            @current_page = val
            return

        edit_absence: (absence)->
            # console.log 'EDIT A ', absence
            @$emit('edit-absence', absence)
            return

        delete_absence: (absence_uid)->
            @$emit('delete-absence', absence_uid)
            return

        accept_absence: (absence)->
            old_state_slug = absence.state.slug
            new_state = "accepte"
            if old_state_slug == "annulation_demandee"
                new_state = "annule"
            absence.user_in_charge_uid = @$store.state.user_datas.app_user.uid
            for state in @$store.state.state_choice_set
                if state.slug == new_state
                    absence.state = t.deep_copy(state)
                    @$emit('accept-absence', absence, old_state_slug)
                    return

        refuse_absence: (absence)->
            old_state_slug = absence.state.slug
            new_state = "refuse"
            if old_state_slug == "annulation_demandee"
                new_state = "accepte"
            absence.user_in_charge_uid = @$store.state.user_datas.app_user.uid
            for state in @$store.state.state_choice_set
                if state.slug == new_state
                    absence.state = t.deep_copy(state)
                    @$emit('refuse-absence', absence, old_state_slug)
                    return

        get_absences: ()->
            self = @
            @loading = true
            q.run('get_absence_set', [@$store.getters.current_company.uid, @component])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error(self.component+"_absences: get_absences: then", e.message)
                else
                    # console.log "GET absences : ", resp.body.data.absence_set
                    self.absences = resp.body.data.absence_set
                    self.loading = false
                    if self.absences.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "absences_table: get_absences()")

    beforeMount: ()->
        @get_absences()
}
